module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game",
    class: {
      'animate': _vm.useAnimations
    }
  }, [_c('header', [_c('div', {
    staticClass: "combo"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v("Damage")]), _vm._v("\n        x" + _vm._s(_vm.damage) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "level",
    on: {
      "click": function($event) {
        _vm.showLevel = !_vm.showLevel
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.centerHeader))]), _vm._v("\n      " + _vm._s(_vm.centerValue) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "clicks-left"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v("Taps")]), _vm._v("\n        " + _vm._s(_vm.clicksLeft) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "combo-progress-wrapper"
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      'width': (_vm.comboPercentage + "%")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "combo-points-progress"
  }, [_vm._v("\n      " + _vm._s(this.multiplierMeter) + " / " + _vm._s(this.comboNeededToLevelUp) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, _vm._l((_vm.tiles), function(tile) {
    return _c('Tile', {
      key: tile.id,
      attrs: {
        "tile": tile,
        "damage": _vm.damage,
        "color": _vm.tileColor
      },
      on: {
        "longPress": _vm.longPress,
        "hitClick": function($event) {
          _vm.startChainReaction(tile)
        }
      }
    })
  })), _vm._v(" "), _c('footer', [_c('p', {
    staticClass: "small-header"
  }, [_vm._v("Power ups")]), _vm._v(" "), _c('div', {
    staticClass: "power-ups"
  }, _vm._l((_vm.powerUps.filter(function (x) { return x.show; })), function(powerup) {
    return _c('div', {
      key: powerup.id,
      staticClass: "power-up-wrapper"
    }, [_c('button', {
      staticClass: "power-up",
      class: {
        'active': _vm.activePowerUp && powerup.id === _vm.activePowerUp.id
      },
      attrs: {
        "disabled": powerup.amount < 1
      },
      on: {
        "click": function($event) {
          _vm.selectPowerUp(powerup)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-fw",
      class: powerup.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(powerup.amount))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "new-power-up-wrapper",
    class: {
      'show': _vm.test.id > -1
    }
  }, [_c('div', {
    staticClass: "new-power-up"
  }, [_c('h3', {
    staticClass: "new-power-up-name"
  }, [_vm._v("New power up!")]), _vm._v(" "), _c('div', {
    staticClass: "new-power-up-image"
  }, [_c('i', {
    staticClass: "fas fa-fw",
    class: _vm.test.icon
  })]), _vm._v(" "), _c('h3', {
    staticClass: "new-power-up-name"
  }, [_vm._v(_vm._s(_vm.test.name))])])]), _vm._v(" "), (_vm.gameOver) ? _c('RetryMenu', {
    attrs: {
      "score": _vm.score,
      "runningInApp": _vm.runningInApp,
      "alreadyRewarded": _vm.alreadyRewarded
    },
    on: {
      "retry": _vm.reset,
      "reward": _vm.reward
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39185b57","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 112
// module chunks = 1